import { observer } from "mobx-react-lite"

import type { VenammSellStore } from "@/domains/venamm"
import { MessageBoxIcon } from "@/domains/common/components/message-box-icon"
import { ShortMessageBox } from "@/domains/common/components/short-message-box"
import { BodySM } from "@/domains/design/components/body-sm"

interface VenammApprovingProps {
  store: VenammSellStore
}

export const VenammApproving = observer(({ store }: VenammApprovingProps) => {
  return (
    <ShortMessageBox variant="info" icon={<MessageBoxIcon size={"md"} variant="info" />}>
      <BodySM className="text-t200">Approving Venamm contract to spend your NFT...</BodySM>
    </ShortMessageBox>
  )
})

